export default {
    apiGateway: {
        REGION: "eu-west-1",
        URL: "https://t76ojyk5b1.execute-api.eu-west-1.amazonaws.com/dev"
    }
};
  